import config from "config/config";

export const getAgentPrechatInfo = (
  portalChatID,
  user,
  selectedMainCategory,
  subCategories,
  prechatFormData
) => {
  return {
    extraPrechatInfo: [
      {
        entityName: "Contact",
        showOnCreate: false,
        entityFieldMaps: [
          {
            isExactMatch: true,
            fieldName: "FirstName",
            doCreate: false,
            doFind: false,
            label: "First Name",
          },
        ],
      },
      {
        entityName: "Case",
        showOnCreate: true,
        entityFieldMaps: [
          ...(config.ENABLE_POST_CHAT_SURVEY === "true"
            ? [
                {
                  isExactMatch: true,
                  fieldName: "CRM_Portal_Chat_ID__c",
                  doCreate: true,
                  doFind: false,
                  label: "Portal Chat ID",
                },
              ]
            : []),
          {
            isExactMatch: true,
            fieldName: "CRM_Caller_Name__c",
            doCreate: true,
            doFind: false,
            label: "Caller Name",
          },
          {
            isExactMatch: true,
            fieldName: "CRM_Caller_Type__c",
            doCreate: true,
            doFind: false,
            label: "Caller type",
          },
          {
            isExactMatch: true,
            fieldName: "CRM_Agent_ID__c",
            doCreate: true,
            doFind: false,
            label: "Agent ID",
          },
          {
            isExactMatch: true,
            fieldName: "CRM_Atl_Agent_Id__c",
            doCreate: true,
            doFind: false,
            label: "Alt Agent ID",
          },
          {
            isExactMatch: true,
            fieldName: "CRM_Agent_Email__c",

            doCreate: true,
            doFind: false,
            label: "Agent Email",
          },
          {
            isExactMatch: true,
            fieldName: "CRM_Agent_Phone__c",
            doCreate: true,
            doFind: false,
            label: "Agent Phone",
          },
          {
            isExactMatch: true,
            fieldName: "CRM_Category__c",
            doCreate: true,
            doFind: false,
            label: "Chat Category",
          },
          {
            isExactMatch: true,
            fieldName: "CRM_Issue_Type__c",
            doCreate: true,
            doFind: false,
            label: "Chat Issue Type",
          },
          {
            isExactMatch: true,
            fieldName: "CRM_Policy__c",
            doCreate: true,
            doFind: false,
            label: "Policy ID",
          },
          {
            isExactMatch: true,
            fieldName: "CRM_Old_Policy__c",
            doCreate: true,
            doFind: false,
            label: "Old Policy ID",
          },
          {
            isExactMatch: true,
            fieldName: "Description",
            doCreate: true,
            doFind: false,
            label: "Description",
          },
          {
            isExactMatch: true,
            fieldName: "GiDP_CarrierName__c",
            doCreate: true,
            doFind: false,
            label: "Carrier Name",
          },
          {
            isExactMatch: true,
            fieldName: "GiDP_CarrierCode__c",
            doCreate: true,
            doFind: false,
            label: "Carrier Code",
          },
        ],
      },
    ],
    extraPrechatFormDetails: [
      ...(config.ENABLE_POST_CHAT_SURVEY === "true"
        ? [
            {
              label: "Portal Chat ID",
              value: portalChatID,
              transcriptFields: [],
              displayToAgent: true,
            },
          ]
        : []),
      {
        label: "First Name",
        value: `${user.firstName} ${user.lastName}`,
        transcriptFields: [],
        displayToAgent: true,
      },
      {
        label: "Caller Name",
        value: `${user.firstName} ${user.lastName}`,
        transcriptFields: [],
        displayToAgent: true,
      },
      {
        label: "Caller type",
        value: "Agent",
        transcriptFields: [],
        displayToAgent: true,
      },
      {
        label: "Agent ID",
        value: user.agentID,
        transcriptFields: [],
        displayToAgent: true,
      },
      {
        label: "Alt Agent ID",
        value: user.alternateAgentID,
        transcriptFields: [],
        displayToAgent: true,
      },
      {
        label: "Agent Email",
        value: user.emailId,
        transcriptFields: [],
        displayToAgent: true,
      },
      {
        label: "Agent Phone",
        value: user.mobile,
        transcriptFields: [],
        displayToAgent: true,
      },
      {
        label: "Chat Category",
        value: selectedMainCategory,
        transcriptFields: [],
        displayToAgent: true,
      },
      {
        label: "Chat Issue Type",
        value: subCategories[selectedMainCategory].find(
          (sub) => prechatFormData.subCategory === sub.id
        )?.name,
        transcriptFields: [],
        displayToAgent: true,
      },
      {
        label: "Policy ID",
        value:
          prechatFormData.policyNumber === "n/a"
            ? "Not Applicable"
            : JSON.parse(prechatFormData.policyNumber).contractId,
        transcriptFields: [],
        displayToAgent: true,
      },
      {
        label: "Old Policy ID",
        value:
          prechatFormData.policyNumber === "n/a"
            ? "Not Applicable"
            : JSON.parse(prechatFormData.policyNumber).oldPolicy,
        transcriptFields: [],
        displayToAgent: true,
      },
      {
        label: "Description",
        value: prechatFormData.message,
        transcriptFields: [],
        displayToAgent: true,
      },
      {
        label: "Carrier Name",
        value: config.CLIENTNAME,
        transcriptFields: [],
        displayToAgent: true,
      },
      {
        label: "Carrier Code",
        value: config.COMPANY,
        transcriptFields: [],
        displayToAgent: true,
      },
    ],
  };
};
